module.exports = __webpack_public_path__ + "img/card_lie_down.3a5e7a8d.gif";